import React, { useEffect, useState, useRef } from 'react'
import loginimg from './login.jpg'
import { Alert, Button, ButtonGroup, Card, CardBody, CardTitle, Col, Form, FormGroup, Input, InputGroup, InputGroupText, Label, Row, Spinner } from 'reactstrap'
import { Link, useLocation } from 'react-router-dom'
import { MdDrafts, MdSend } from "react-icons/md";
import { FaCalendar, FaPlusCircle, FaTrash, FaUser } from "react-icons/fa";
import { FaRepeat } from 'react-icons/fa6';
import axios from 'axios';
import PhotoUploadOrCapture from './PhotoUploadOrCapture';
import OtpInput from 'react-otp-input';
import ReCAPTCHA from "react-google-recaptcha";
import { useSelector, useDispatch } from 'react-redux';
import {
    setError, setSubmited, setFname, setLname, setEmail, setPhone, sendLnk, setFathername, setDob,
    setAddressprfExp, setIdproofExp, setAddressVCity, setAddressVState, setAddressVCountry, setAddressline2, setAddressline1,
    setMother_language, setOther_spoken_language,
    setCitizenship, setAlsname, setBcountry, setAddress, setCity, setCountry, setGender, setMname, setState
} from './app/features/sendLinkSlice';

import qs from 'qs';
import LiveLocation from './LiveLocation';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import Select from "react-select";


const languageOptions = [
    { value: "english", label: "English" },
    { value: "bengali", label: "Bengali" },
    { value: "hindi", label: "Hindi" },
    { value: "urdu", label: "Urdu" },
    { value: "arabic", label: "Arabic" },
    { value: "french", label: "French" },
    { value: "german", label: "German" },
    { value: "spanish", label: "Spanish" },
    { value: "italian", label: "Italian" },
    { value: "russian", label: "Russian" },
    { value: "chinese", label: "Chinese" },
    { value: "japanese", label: "Japanese" },
    { value: "korean", label: "Korean" },
    { value: "portuguese", label: "Portuguese" },
    { value: "turkish", label: "Turkish" }
];


function Login() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const customer_type = queryParams.get('customer');
    const user_id = queryParams.get('id');
    const dispatch = useDispatch();
    const inputRef = useRef(null);

    const [time, setTime] = useState(new Date());


    // Redux state
    const { error, submited, fname, lname, fathername, dob, email, phone, id_proof_exp, adress_prf_exp,
        mname, alisname, bcountry, gender, country, state, city, pin, address, citizenship, mother_language, other_spoken_language,
        addressline1, addressline2, addressVCountry, addressVState, addressVCity
    } = useSelector((state) => state.sendKyc);

    // Local state
    const [idProofFile, setidProofFile] = useState(null);
    const [idProobkfFile, setidProofbkFile] = useState(null);
    const [profilephotoFile, setProfilephotoFile] = useState(null);
    const [image, setImage] = useState(null);
    const [addressFile, setaddressFile] = useState(null);
    const [uploadDatas, setUploads] = useState(false);
    const [govtDetails, setGovtDetails] = useState([]);
    const [govtDetailsList, setGovtDetailsList] = useState([]);
    const [locationData, setLocationData] = useState(null);
    const [isRecording, setIsRecording] = useState(false);
    const [videoUrl, setVideoUrl] = useState('');
    const [videoBlob, setVideoBlob] = useState(null);
    const mediaRecorderRef = useRef(null);
    const streamRef = useRef(null);
    const videoRef = useRef(null);
    const [numberVideo, setNumVideo] = useState(0);
    const [note, setNote] = useState('');
    const [otp, setOotp] = useState('');
    const [checkOtp, setOtp] = useState(null)
    const [EmailLoading, setEmailLoading] = useState(false)
    const [Emailverifyed, setEmailverifyed] = useState(false)
    const [submitDiseable, setsubmitDiseable] = useState(true)
    const [qusList, setQusList] = useState([])
    const [streama, setStream] = useState(null);
    const recordingLimit = 60 * 2000; // 1 minute in milliseconds

    // Video recording logic
    const startRecording = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
            setStream(stream);
            streamRef.current = stream;
            if (videoRef.current) {
                videoRef.current.srcObject = stream;
                videoRef.current.play();
            }
            let chunks = [];
            mediaRecorderRef.current = new MediaRecorder(stream);
            mediaRecorderRef.current.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    chunks.push(event.data);
                }
            };
            mediaRecorderRef.current.onstop = () => {
                const blob = new Blob(chunks, { type: 'video/webm' });
                setVideoBlob(blob);
                setVideoUrl(URL.createObjectURL(blob));
                setNumVideo(1);
                chunks = [];
            };
            mediaRecorderRef.current.start();
            setIsRecording(true);
            setTimeout(() => {
                alert('Please stop recording ')
            }, recordingLimit);
        } catch (err) {
            console.error('Error accessing media devices.', err);
        }
    };

    const stopRecording = () => {
        if (mediaRecorderRef.current) {
            mediaRecorderRef.current.stop();
            mediaRecorderRef.current.stream.getTracks().forEach(track => track.stop());
            setIsRecording(false);
            setNumVideo(1);
        }
    };
    const savedDraft = () => {
        const alldata = {
            fname: fname, lname: lname, email: email, phone: phone, fathername: fathername, dob: dob,
            customer_type: customer_type ? customer_type : '',
            user_id: user_id ? user_id : '', log_details: JSON.stringify(locationData),
            mname: mname,
            alisname: alisname,
            bcountry: bcountry,
            gender: gender,

            country: country,
            state: state,
            city: city,
            address: address,
            pin: pin,
            citizenship: citizenship,
            // log_details: JSON.stringify(locationData),

        };
        localStorage.setItem('formDraft', JSON.stringify(alldata));
        console.log(alldata);
        fetch('https://idverify.emphasispay.com/api/saved-draft.php', {
            method: 'POST',
            body: JSON.stringify(alldata)
        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);
            })
            .catch(error => {
                console.error('Error:', error);
            });

    }

    useEffect(() => {
        fetch('https://ipapi.co/json/')
            .then((response) => response.json())
            .then((data) => setLocationData(data))
            .catch((error) => console.error('Error fetching IP/location:', error));
    }, []);

    const onChange = (value) => {
        // handle recaptcha
    }

    const uploadGovtId = async () => {
        setUploads(true)
        const formData1 = new FormData();
        formData1.append('email', email);
        formData1.append('file_type', govtDetails.file_type);
        formData1.append('id_exp_date', govtDetails.id_exp_date);
        formData1.append('upload_b_sde', govtDetails.upload_b_sde);
        formData1.append('upload_f_sde', govtDetails.upload_f_sde);
        try {
            const response = await axios.post('https://idverify.emphasispay.com/api/upload-id-proof.php', formData1, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            setUploads(false)
            if (!response.data.error) {
                setGovtDetailsList((prev) => [...prev, response.data.result])
                setGovtDetails({ file_type: '', id_exp_date: '', upload_b_sde: '', upload_f_sde: '' });
            }
        } catch (error) {
            setUploads(false)
        }
    }

    // Main form submit: now includes videoBlob
    const [countryes, setCountryes] = useState([]);
    const [states, setStates] = useState([]);
    const [states2, setStates2] = useState([]);
    const [citys, setCitys] = useState([]);
    const [citys2, setCitys2] = useState([]);



    const handalSubmit = async (e) => {
        e.preventDefault();
        if (fname === '') return dispatch(setError('Please enter your name!'));
        if (email === '') return dispatch(setError('Please enter your email!'))
        if (phone === '') return dispatch(setError('Please nter your mobile number!'))

        dispatch(setError(null));

        const data = {
            fname: fname, lname: lname, email: email, phone: phone, fathername: fathername, dob: dob,
            customer_type: customer_type ? customer_type : '',
            user_id: user_id ? user_id : '', log_details: JSON.stringify(locationData),
            mname: mname,
            alisname: alisname,
            bcountry: bcountry,
            gender: gender,

            country: country,
            state: state,
            city: city,
            address: address,
            pin: pin,
            citizenship: citizenship,

        };

        // Prepare FormData for file uploads and video
        const formData = new FormData();

        formData.append('email', email);
        formData.append('profile_photo', profilephotoFile);
        formData.append('address_proof', addressFile);
        formData.append('id_proof_exp', id_proof_exp);
        formData.append('adress_prf_exp', adress_prf_exp);

        // Append video if available
        if (videoBlob) {
            formData.append('video_file', videoBlob, Date.now() + '_recorded-video.webm');
        }

        // Append other form fields
        Object.entries(data).forEach(([key, value]) => {
            formData.append(key, value);
        });
        try {
            const response = await axios.post('https://idverify.emphasispay.com/api/upload-data.php', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            localStorage.removeItem('formDraft');


            console.log('Upload response:', response.data); // 👈 Inspect the server response

            if (response.data && !response.data.error) {
                // If the upload succeeded
                dispatch(sendLnk(data));
                dispatch(setSubmited(true));

                // Clear form data
                dispatch(setFname(''));
                dispatch(setLname(''));
                dispatch(setEmail(''));
                dispatch(setPhone(''));
                dispatch(setDob(''));
                dispatch(setFathername(''));
                setVideoBlob(null);
                setVideoUrl('');
                setNumVideo(0);
            } else {
                // If server responded with an error
                dispatch(setError(response.data?.result || 'Unknown error occurred.'));
            }
        } catch (error) {
            console.error('API request failed:', error);
            dispatch(setError('File upload failed'));
        }

        // try {
        //     await axios.post('https://nuggettrap.com/api/ekyc/upload-data.php', formData, {
        //         headers: { 'Content-Type': 'multipart/form-data' }
        //     });

        //     dispatch(sendLnk(data))
        //     dispatch(setSubmited(true))
        //     dispatch(setFname(''));
        //     dispatch(setLname(''));
        //     dispatch(setEmail(''));
        //     dispatch(setPhone(''));
        //     dispatch(setDob(''));
        //     dispatch(setFathername(''));
        //     setVideoBlob(null);
        //     setVideoUrl('');
        //     setNumVideo(0);
        // } catch (error) {
        //     dispatch(setError('File upload failed'));
        // }
    }

    const sendEmial = () => {
        if (email === '') return dispatch(setError('Please enter your email!'))
        setEmailLoading(true);
        dispatch(setError(null));
        fetch('https://idverify.emphasispay.com/api/send-email.php', {
            method: 'POST',
            body: JSON.stringify({ email: email })
        })
            .then((res) => res.json())
            .then((result) => {
                setEmailLoading(false);
                if (!result.error) {
                    setOtp(result.otp)
                    if (inputRef.current) {
                        inputRef.current.focus();
                    }
                } else {
                    alert(result.result);
                    dispatch(setEmail(''));
                }
            })
    }

    const handalPushDetails = () => {
        if (govtDetailsList.length <= 2 && govtDetails.file_type && govtDetails.id_exp_date) {
            if (govtDetails.file_type !== '' && govtDetails.id_exp_date !== '') {
                uploadGovtId();
            }
        }
    }

    const handalDelete = async (dellist) => {
        var allList = govtDetailsList.filter(list => list.id !== dellist.id)
        setGovtDetailsList(allList)
        await axios.post(`https://idverify.emphasispay.com/api/delete-id-proof.php?id=${dellist.id}`);
    }

    const verifyOtp = () => {
        if (email === '') return dispatch(setError('Please enter your email!'))
        if (otp === '') return dispatch(setError('Please enter OTP!'));
        dispatch(setError(null));
        if (otp === checkOtp) {
            setsubmitDiseable(false)
            setEmailverifyed(true)
        } else {
            return dispatch(setError('Please enter Valid OTP!'));
        }
    }

    const handalPhoto = (e) => {
        setProfilephotoFile(e)
    }
    const getStates = async (countryId) => {
        if (!countryId) {
            setStates([]);
            return;
        }
        const data = qs.stringify({
            method: 'get_state_',
            countryId: countryId,
        });

        try {
            const response = await axios.post(
                'https://axepay.com/sadmin/ajax/country.state.php',
                data,
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                }
            );
            setStates(response.data.data || []);
        } catch (error) {
            console.error('Failed to fetch states:', error);
            setStates([]);
        }
    }
    const getStates2 = async (countryId) => {
        if (!countryId) {
            setStates([]);
            return;
        }
        const data = qs.stringify({
            method: 'get_state_',
            countryId: countryId,
        });

        try {
            const response = await axios.post(
                'https://axepay.com/sadmin/ajax/country.state.php',
                data,
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                }
            );
            setStates2(response.data.data || []);
        } catch (error) {
            console.error('Failed to fetch states:', error);
            setStates2([]);
        }
    }

    /*
     elseif ($_POST['method'] == 'get_city_') {

        $stateId = $_POST['stateId'];

    */
    const getCitys = async (stateId) => {
        if (!stateId) {
            setCitys([]);
            return;
        }
        const data = qs.stringify({
            method: 'get_city_',
            stateId: stateId,
        });

        try {
            const response = await axios.post(
                'https://axepay.com/sadmin/ajax/country.state.php',
                data,
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                }
            );
            setCitys(response.data.data || []);
        } catch (error) {
            console.error('Failed to fetch states:', error);
            setCitys([]);
        }
    }
    const getCitys2 = async (stateId) => {
        if (!stateId) {
            setCitys2([]);
            return;
        }
        const data = qs.stringify({
            method: 'get_city_',
            stateId: stateId,
        });

        try {
            const response = await axios.post(
                'https://axepay.com/sadmin/ajax/country.state.php',
                data,
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                }
            );
            setCitys2(response.data.data || []);
        } catch (error) {
            console.error('Failed to fetch states:', error);
            setCitys2([]);
        }
    }

    useEffect(() => {
        if (qusList.length === 0) {
            fetch('https://idverify.emphasispay.com/api/get-qus-list.php')
                .then((rs) => rs.json())
                .then((resul) => {
                    setQusList(resul.result);
                })
        }
    }, [qusList])



    useEffect(() => {
        const savedForm = localStorage.getItem('formDraft');
        console.log(savedForm);
        if (savedForm) {
            const data = JSON.parse(savedForm);
            console.log(data);
            if (data.fname) dispatch(setFname(data.fname));
            if (data.mname) dispatch(setMname(data.mname));
            if (data.lname) dispatch(setLname(data.lname));
            if (data.email) dispatch(setEmail(data.email));
            if (data.phone) dispatch(setPhone(data.phone));
            if (data.fathername) dispatch(setFathername(data.fathername));
            if (data.dob) dispatch(setDob(data.dob));
            if (data.citizenship) dispatch(setCitizenship(data.citizenship));
            if (data.alsname) dispatch(setAlsname(data.alsname));
            if (data.bcountry) dispatch(setBcountry(data.bcountry));
            if (data.address) dispatch(setAddress(data.address));
            if (data.city) dispatch(setCity(data.city));
            if (data.country) dispatch(setCountry(data.country));
            if (data.gender) dispatch(setGender(data.gender));
            if (data.state) dispatch(setState(data.state));
        }
    }, [dispatch]);

    useEffect(() => {
        const fetchCountries = async () => {
            const data = qs.stringify({
                method: 'country'
            });

            const config = {
                method: 'post',
                url: 'https://axepay.com/sadmin/ajax/country.state.php',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    // Only include PHPSESSID cookie if absolutely required
                    'Cookie': 'PHPSESSID=s84av6cdm3cdnra45jpis0ucqi'
                },
                data: data
            };

            try {
                const response = await axios.request(config);
                console.log(response.data); // Log response
                setCountryes(response.data.data); // Assuming JSON includes 'data' field
            } catch (error) {
                console.error('Failed to fetch countries:', error);
            } finally {
                // setLoading(false);
            }
        };

        fetchCountries();
    }, []);

    return (
        <div className='login-main'>
            <Row className='row-login'>
                <Col md={12}>
                    <div className='login-box'>
                        <h2 className='text-center'>Send EKYC link</h2>
                        <p>Go to <Link to='/login'>login page</Link> </p>
                        <div>
                            <LiveLocation />
                        </div>

                        <form method='post' className='log-form' onSubmit={handalSubmit}>
                            {location.state && location.state.message &&
                                <Alert color='danger'>{location.state.message}</Alert>
                            }
                            {error && <p className='text-danger'>{error}</p>}
                            {submited && <p className='text-success'>Please check your email</p>}
                            <Row>
                                <Col md={3}>
                                    <FormGroup>
                                        <InputGroup>
                                            <InputGroupText>
                                                <FaUser color='#2a278e' size={20} />
                                            </InputGroupText>
                                            <Input placeholder='Enter your first name' value={fname}
                                                onChange={(e) => { dispatch(setFname(e.target.value)) }}
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <InputGroup>
                                            <InputGroupText>
                                                <FaUser color='#2a278e' size={20} />
                                            </InputGroupText>
                                            <Input placeholder='Enter your Middle name'
                                                value={mname} onChange={(e) => { dispatch(setMname(e.target.value)) }}
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <InputGroup>
                                            <InputGroupText>
                                                <FaUser color='#2a278e' size={20} />
                                            </InputGroupText>
                                            <Input placeholder='Enter your last name' value={lname}
                                                onChange={(e) => { dispatch(setLname(e.target.value)) }}
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>


                                <Col md={3}>
                                    <FormGroup>
                                        <InputGroup>
                                            <InputGroupText>
                                                <FaUser color='#2a278e' size={20} />
                                            </InputGroupText>
                                            <Input placeholder='Enter your alias  name'
                                                value={alisname} onChange={(e) => { dispatch(setAlsname(e.target.value)) }}
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={3}>
                                    <Label className='dob-label'>Date of birth</Label>
                                    <FormGroup>
                                        <InputGroup>
                                            <InputGroupText>
                                                <FaCalendar color='#2a278e' size={20} />
                                            </InputGroupText>
                                            <Input value={dob}
                                                type='date' onChange={(e) => { dispatch(setDob(e.target.value)) }}
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                {/* 
                                
                                 */}
                                <Col md={3}>
                                    <FormGroup>
                                        <div>
                                            <Label>Gender</Label>
                                            <Input type='select' value={gender} onChange={(e) => { dispatch(setGender(e.target.value)) }}>
                                                <option value=''>Select option</option>
                                                <option value='male'>Male</option>
                                                <option value='female'>Female</option>
                                                <option value='female'>Female</option>
                                                <option value='non-binary'>Non-Binary</option>
                                                {/*  /  */}
                                            </Input>
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup >
                                        <Label>Has your gender legally changed from your sex assigned at birth?</Label>
                                        <FormGroup check>
                                            <Input
                                                name="genderChange"
                                                type="select"
                                            >
                                                <option value="">Select option</option>
                                                <option value="yes">Yes</option>
                                                <option value="no">No</option>
                                            </Input>
                                        </FormGroup>

                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label>If Yes, please specify your previous gender marker</Label>
                                        <InputGroup>
                                            <Input placeholder='If Yes - Specify'
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <hr />
                                {/* <Col md={4}>
                                    <Label className='dob-label'>Country Of Birth</Label>
                                    <FormGroup>
                                        <InputGroup>
                                            <Input type='select' value={bcountry} onChange={(e) => { dispatch(setBcountry(e.target.value)); getStates(e.target.value) }} >
                                                <option value=''>Select option</option>
                                                {countryes.map((cuntry) => (
                                                    <option key={cuntry.id} value={cuntry.id}>
                                                        {cuntry.name || 'Unnamed '}
                                                    </option>
                                                ))}
                                            </Input>
                                        </InputGroup>
                                    </FormGroup>
                                </Col> */}
                                <Col md={4}>
                                    <Label className='dob-label'>Country Of Birth</Label>
                                    <FormGroup tyle={{ width: "250px" }}>
                                        <InputGroup style={{ width: "250px" }}>
                                            <Select style={{ width: "250px" }}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                placeholder="Search Country..."
                                                value={
                                                    countryes.find((item) => item.id === bcountry)
                                                        ? {
                                                            value: bcountry,
                                                            label: countryes.find((item) => item.id === bcountry).name
                                                        }
                                                        : null
                                                }
                                                onChange={(selectedOption) => {
                                                    dispatch(setBcountry(selectedOption.value));
                                                    getStates(selectedOption.value);
                                                }}
                                                options={countryes.map((country) => ({
                                                    value: country.id,
                                                    label: country.name || "Unnamed"
                                                }))}
                                                isSearchable={true}
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                {/* add cityzenship */}
                                <Col md={4}>
                                    <Label className='dob-label'>Nationality</Label>
                                    <FormGroup>
                                        <InputGroup style={{ width: "100%" }}>
                                            <Select
                                                className="basic-single"
                                                classNamePrefix="select"
                                                placeholder="Search Citizenship..."
                                                styles={{
                                                    container: (provided) => ({
                                                        ...provided,
                                                        width: "100%"
                                                    })
                                                }}
                                                value={
                                                    countryes.find((item) => item.id === citizenship)
                                                        ? {
                                                            value: citizenship,
                                                            label: countryes.find((item) => item.id === citizenship).name
                                                        }
                                                        : null
                                                }
                                                onChange={(selectedOption) => {
                                                    dispatch(setCitizenship(selectedOption.value));
                                                    getStates(selectedOption.value);
                                                }}
                                                options={countryes.map((country) => ({
                                                    value: country.id,
                                                    label: country.name || "Unnamed"
                                                }))}
                                                isSearchable={true}
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <Label className='dob-label'>Native or Mother Tongue</Label>
                                    <FormGroup>
                                        <InputGroup style={{ width: "100%" }}>
                                            <Select
                                                className="basic-single"
                                                classNamePrefix="select"
                                                placeholder="Search Language..."
                                                styles={{
                                                    container: (provided) => ({
                                                        ...provided,
                                                        width: "100%"
                                                    })
                                                }}
                                                // value={mother_language}
                                                value={languageOptions.find(
                                                    (option) => option.value === mother_language
                                                )}
                                                onChange={(e) => { console.log(e.value); dispatch(setMother_language(e.value)) }}

                                                options={languageOptions}
                                                isSearchable={true}
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                {/* Other Spoken Languages */}
                                <Col md={4}>
                                    <Label className='dob-label'>Other Spoken Languages</Label>
                                    <FormGroup>
                                        <InputGroup style={{ width: "100%" }}>
                                            <Select
                                                className="basic-single"
                                                classNamePrefix="select"
                                                placeholder="Search Language..."
                                                styles={{
                                                    container: (provided) => ({
                                                        ...provided,
                                                        width: "100%"
                                                    })
                                                }}
                                               /// value={other_spoken_language}
                                               value={languageOptions.find(
                                                    (option) => option.value === other_spoken_language
                                                )}
                                                onChange={(e) => { dispatch(setOther_spoken_language(e.value)) }}
                                                /// onChange={(e) => { console.log(e)}}
                                                options={languageOptions}
                                                isSearchable={true}
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <div>
                                            <Label>Country</Label>
                                            <Select
                                                className="basic-single"
                                                classNamePrefix="select"
                                                placeholder="Search Country..."
                                                styles={{
                                                    container: (provided) => ({
                                                        ...provided,
                                                        width: "100%"
                                                    })
                                                }}
                                                value={
                                                    countryes.find((item) => item.id === country)
                                                        ? {
                                                            value: country,
                                                            label: countryes.find((item) => item.id === country).name
                                                        }
                                                        : null
                                                }
                                                onChange={(selectedOption) => {
                                                    dispatch(setCountry(selectedOption.value));
                                                    getStates(selectedOption.value);
                                                }}
                                                options={countryes.map((countryItem) => ({
                                                    value: countryItem.id,
                                                    label: countryItem.name || "Unnamed"
                                                }))}
                                                isSearchable={true}
                                            />
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label>State / Province</Label>
                                        <FormGroup>
                                            <Input type='select' value={city} onChange={(e) => {
                                                dispatch(setCity(e.target.value)); getCitys(e.target.value)
                                            }} >
                                                <option value=''>Select state</option>
                                                {states.map((states) => (
                                                    <option key={states.id} value={states.id}>
                                                        {states.name || 'Unnamed '}
                                                    </option>
                                                ))}
                                            </Input>
                                        </FormGroup>
                                    </FormGroup>
                                </Col>
                                <Col md={3}>

                                    <FormGroup>
                                        <Label style={{ marginBottom: '0px' }}>City</Label>
                                        <InputGroup>
                                            <Input type='select' value={city} onChange={(e) => { dispatch(setCity(e.target.value)) }} >
                                                <option value=''>Select City</option>
                                                {citys.map((cuntry) => (
                                                    <option key={cuntry.id} value={cuntry.id}>
                                                        {cuntry.name || 'Unnamed '}
                                                    </option>
                                                ))}
                                            </Input>
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <Label className='dob-label'>Address</Label>
                                    <FormGroup>
                                        <InputGroup>
                                            <Input placeholder='Address'
                                                value={address} onChange={(e) => { dispatch(setAddress(e.target.value)) }}
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <Label className='dob-label'>Zip / Postal Code</Label>
                                    <FormGroup>
                                        <InputGroup>
                                            <Input placeholder='Postal Code '
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                {/* Citizenship */}
                                <Col md={3}>
                                    <Label className='dob-label'>Citizenship</Label>
                                    <FormGroup>
                                        <InputGroup style={{ width: "100%" }}>
                                            <Select
                                                className="basic-single"
                                                classNamePrefix="select"
                                                placeholder="Search Citizenship..."
                                                styles={{
                                                    container: (provided) => ({
                                                        ...provided,
                                                        width: "100%"
                                                    })
                                                }}
                                                value={
                                                    countryes.find((item) => item.id === citizenship)
                                                        ? {
                                                            value: citizenship,
                                                            label: countryes.find((item) => item.id === citizenship).name
                                                        }
                                                        : null
                                                }
                                                onChange={(selectedOption) => {
                                                    dispatch(setCitizenship(selectedOption.value));
                                                    getStates(selectedOption.value);
                                                }}
                                                options={countryes.map((country) => ({
                                                    value: country.id,
                                                    label: country.name || "Unnamed"
                                                }))}
                                                isSearchable={true}
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>


                            </Row>
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <InputGroup>
                                            <InputGroupText>
                                                <MdDrafts color='#2a278e' size={20} />
                                            </InputGroupText>
                                            <Input placeholder='Enter your Email' value={email}
                                                onChange={(e) => { dispatch(setEmail(e.target.value)) }} />
                                            <InputGroupText>
                                                <MdSend color='#2a278e' size={20} className='send-button'
                                                    onClick={sendEmial} />
                                            </InputGroupText>
                                        </InputGroup>
                                    </FormGroup>
                                    <span>Click <MdSend /> Send button to get OTP</span>
                                </Col>
                                <Col md={3} className='otp-box'>
                                    <OtpInput
                                        value={otp}
                                        onChange={setOotp}
                                        numInputs={4} className='form-control'
                                        renderSeparator={<span>-</span>}
                                        renderInput={(props) => <input {...props} />}
                                    />
                                </Col>
                                <Col md={3}>
                                    <ButtonGroup>
                                        {EmailLoading ? (
                                            <Spinner color="info" >
                                                Loading...
                                            </Spinner>
                                        ) : (
                                            <>
                                                {Emailverifyed ? (
                                                    <Button color='success' type='button' >Verifyed</Button>
                                                ) : (
                                                    <Button color='danger' type='button' onClick={verifyOtp}>Verify</Button>
                                                )}
                                                <Button color="warning" type='button' onClick={sendEmial}>
                                                    <FaRepeat />
                                                </Button>
                                            </>
                                        )}
                                    </ButtonGroup>
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col md={6}>
                                    <Label className='dob-label'>Phone</Label>
                                    <FormGroup>
                                        <PhoneInput
                                            defaultCountry="us"
                                            value={phone}
                                            onChange={(e) => { dispatch(setPhone(e)) }}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <Label className='dob-label'>Are you a Political Exposed person:</Label>
                                    <FormGroup>
                                        <InputGroup>
                                            <Input
                                                type='select'

                                            >
                                                <option value=''>Select option</option>
                                                <option value='yes'>Yes</option>
                                                <option value='no'>No</option>
                                            </Input>
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col md={8}>
                                    {image &&
                                        <img src={image} alt="photo" className='profile-img-r' />
                                    }
                                </Col>
                                <Col md={4}>

                                </Col>
                            </Row>
                            <Row>
                                <Col md={8}>
                                    <PhotoUploadOrCapture getPhoto={handalPhoto} />
                                </Col>
                                <Col md={4}>
                                    <div>
                                        {isRecording ? (
                                            <Button color='danger' onClick={stopRecording}>Stop Recording  </Button>
                                        ) : (
                                            <>
                                                {numberVideo === 0 &&
                                                    <Button color='danger' onClick={startRecording}>
                                                        <Spinner
                                                            color="light"
                                                            size="sm"
                                                            type="grow"
                                                        >
                                                            Loading...
                                                        </Spinner>
                                                        Start Recording </Button>
                                                }
                                            </>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            <hr />
                            <div className='text-center'>
                                <video ref={videoRef} autoPlay playsInline className='video-box' style={{ height: '200px' }} />

                                {videoUrl && (
                                    <div>
                                        <video src={videoUrl} controls style={{ width: '100%', marginTop: 10 }} />
                                    </div>
                                )}
                            </div>
                            <p>
                                Please state your legal name, Date of birth and Address after clicking the record button

                            </p>
                            <hr />
                            <h4>Identity Verification</h4>
                            <p>Please upload a clear, color copy of your government-issued ID. Ensure all corners are visible and there is no glare.</p>
                            <div className='custom-row'>
                                <div>
                                    <Label>Id Proof type</Label>
                                    <Input type='select' value={govtDetails.file_type}
                                        onChange={(e) => { setGovtDetails((prev) => ({ ...prev, file_type: e.target.value })) }}>
                                        <option value=''>Select option</option>
                                        <option value='govt_id'>Govt Id</option>
                                        <option value='drivers_license'>Drivers License</option>
                                        <option value='passport'>Passport</option>
                                    </Input>
                                </div>

                                <div className='uplod-div'>
                                    <Label>Document Number:</Label>
                                    <Input type='text' value={govtDetails.document_number}
                                        onChange={(e) => { setGovtDetails((prev) => ({ ...prev, document_number: e.target.value })) }} />
                                </div>
                                <div>
                                    <FormGroup>
                                        <Label>Id proof issue date </Label>
                                        <InputGroup>
                                            <InputGroupText>
                                                <FaCalendar color='#2a278e' size={20} />
                                            </InputGroupText>
                                            <Input type='date'

                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </div>
                                <div>
                                    <FormGroup>
                                        <Label>Id proof expiry date </Label>
                                        <InputGroup>
                                            <InputGroupText>
                                                <FaCalendar color='#2a278e' size={20} />
                                            </InputGroupText>
                                            <Input value={govtDetails.id_exp_date} type='date'
                                                onChange={(e) => { setGovtDetails((prev) => ({ ...prev, id_exp_date: e.target.value, id: Date.now() })) }}
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </div>
                                <div className='uplod-div'>
                                    <Label> Upload Front Side </Label>
                                    <Input type='file'
                                        onChange={(e) => { setGovtDetails((prev) => ({ ...prev, upload_f_sde: e.target.files[0] })) }} />
                                </div>
                                <div className='uplod-div'>
                                    <FormGroup>
                                        <Label>Upload Back Side </Label>
                                        <Input type='file'
                                            onChange={(e) => { setGovtDetails((prev) => ({ ...prev, upload_b_sde: e.target.files[0] })) }} />
                                    </FormGroup>
                                </div>

                                <div className='div-button'>
                                    {uploadDatas ? (
                                        <Spinner color="info" >
                                            Loading...
                                        </Spinner>
                                    ) : (
                                        <Button type='button' color='primary' onClick={handalPushDetails}>
                                            <FaPlusCircle />
                                        </Button>
                                    )
                                    }
                                </div>
                            </div>
                            {govtDetailsList.length > 0 &&
                                <>
                                    {govtDetailsList.map((list, i) => (
                                        <div className='custom-row' key={i}>
                                            <div>
                                                <p>{list.id_proof_file_type} </p>
                                            </div>
                                            <div>
                                                <p><img src={list.id_proof_front} alt='' style={{ height: '50px' }} />  </p>
                                            </div>
                                            <div>
                                                <p><img src={list.id_proof_back} alt='' style={{ height: '50px' }} /> </p>
                                            </div>
                                            <div>
                                                <p>{list.id_proof_exp_date} </p>
                                            </div>
                                            <div className='div-button_0'>
                                                <Button type='button' color='danger' onClick={() => { handalDelete(list) }}>
                                                    <FaTrash />
                                                </Button>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            }
                            <hr />
                            <h4>Address Verification</h4>
                            <p>Document must be dated within the last 3 months and clearly show your name and residential address.</p>
                            <Row>
                                <Col md={6}>
                                    <Label className='dob-label'>Address Line 1:</Label>
                                    <FormGroup>
                                        <InputGroup>
                                            <Input
                                                type='text' placeholder='Address Line 1'
                                                value={addressline1} onChange={(e) => { dispatch(setAddressline1(e.target.value)) }}
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <Label className='dob-label'>Address Line 2:</Label>
                                    <FormGroup>
                                        <InputGroup>
                                            <Input
                                                type='text' placeholder='Address Line 2'
                                                value={addressline2} onChange={(e) => { dispatch(setAddressline2(e.target.value)) }}
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <FormGroup>
                                        <div>
                                            <Label>Country</Label>

                                            <Select
                                                className="basic-single"
                                                classNamePrefix="select"
                                                placeholder="Search Country..."
                                                styles={{
                                                    container: (provided) => ({
                                                        ...provided,
                                                        width: "100%"
                                                    })
                                                }}

                                                value={countryes
                                                    .map((item) => ({
                                                        value: item.id,
                                                        label: item.name || "Unnamed"
                                                    }))
                                                    .find((item) => item.value == addressVCountry)
                                                }

                                                onChange={(selectedOption) => {
                                                    dispatch(setAddressVCountry(selectedOption.value));
                                                    getStates2(selectedOption.value);
                                                }}

                                                options={countryes.map((countryItem) => ({
                                                    value: countryItem.id,
                                                    label: countryItem.name || "Unnamed"
                                                }))}

                                                isSearchable={true}
                                            />
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label>State / Province</Label>
                                        <FormGroup>
                                            <Input type='select' value={addressVState} onChange={(e) => {
                                                dispatch(setAddressVState(e.target.value)); getCitys2(e.target.value)
                                            }} >
                                                <option value=''>Select state</option>
                                                {states2.map((states) => (
                                                    <option key={states.id} value={states.id}>
                                                        {states.name || 'Unnamed '}
                                                    </option>
                                                ))}
                                            </Input>
                                        </FormGroup>
                                    </FormGroup>
                                </Col>
                                <Col md={4}>

                                    <FormGroup>
                                        <Label style={{ marginBottom: '0px' }}>City</Label>
                                        <InputGroup>
                                            <Input type='select' value={addressVCity} onChange={(e) => { dispatch(setAddressVCity(e.target.value)) }} >
                                                <option value=''>Select City</option>
                                                {citys2.map((cuntry) => (
                                                    <option key={cuntry.id} value={cuntry.id}>
                                                        {cuntry.name || 'Unnamed '}
                                                    </option>
                                                ))}
                                            </Input>
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={3}>
                                    <Label>Address Proof type</Label>
                                    {/*  /  / Bank Statement/ lease agreement / Govt. Issued letter */}
                                    <Input type='select' >
                                        <option value=''>Select option</option>
                                        <option value='utility_bill'>Utility Bill</option>
                                        <option value='mobile_bill'>Mobile Bill</option>
                                        <option value='bank_statement'>Bank Statement</option>
                                        <option value='lease_agreement'>Lease Agreement</option>
                                        <option value='govt_issued_letter'>Govt. Issued Letter</option>
                                    </Input>
                                </Col>

                                <Col md={3}>
                                    <Label>Upload Document</Label>
                                    <Input type='file' onChange={(e) => { setaddressFile(e.target.files[0]) }}
                                    />
                                </Col>
                                {/* <Col md={3}>
                                    <Label>Upload Back side</Label>
                                    <Input type='file'
                                    />
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label>Address proof expiry date </Label>
                                        <InputGroup>
                                            <InputGroupText>
                                                <FaCalendar color='#2a278e' size={20} />
                                            </InputGroupText>
                                            <Input
                                                type='date'
                                                value={adress_prf_exp} onChange={(e) => { dispatch(setAddressprfExp(e.target.value)) }}
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label>Address proof Issue date </Label>
                                        <InputGroup>
                                            <InputGroupText>
                                                <FaCalendar color='#2a278e' size={20} />
                                            </InputGroupText>
                                            <Input
                                                type='date'
                                            />
                                        </InputGroup>
                                    </FormGroup>
                                </Col> */}
                            </Row>
                            <br />
                            {/* <Row>
                                <Col md={12}>
                                    {qusList.length > 0 &&
                                        <>
                                            {qusList.map((qus, i) => (
                                                <Card className="mb-3" key={i}>
                                                    <CardBody>
                                                        <CardTitle tag="h5">{i + 1}. {qus.qus} </CardTitle>
                                                    </CardBody>
                                                </Card>
                                            ))}
                                        </>
                                    }
                                </Col>
                            </Row> */}
                            <ReCAPTCHA
                                sitekey="6LcHwQUpAAAAAG_RZeMJs-oON-mGHGp_2bplJN-O"
                                theme='dark'
                                onChange={onChange}
                            />
                            <FormGroup></FormGroup>
                            <FormGroup>
                                <Button type='submit' color='primary' block
                                    disabled={submitDiseable}
                                >
                                    Send link
                                    <MdSend color='#fff' size={20} />
                                </Button>
                            </FormGroup>

                            <FormGroup>
                                <Button type='button' color='warning' block onClick={savedDraft}
                                >
                                    Save draft
                                    <MdDrafts color='#fff' size={20} />
                                </Button>
                            </FormGroup>
                        </form>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default Login